import { CircleBackgroundWrapper, CircleWrapper } from './styles';

type CircleProps = {
  id: string;
  value: number;
};

const Circle = ({ id, value }: CircleProps) => {
  return (
    <>
      <CircleBackgroundWrapper
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <CircleWrapper
        strokeDasharray={`${value}, 100`}
        stroke={`url(#gradient-${id})`}
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
      />
    </>
  );
};

export default Circle;
